import { ApiQueryConfig } from 'api/types';
import { createApiEndpoint } from 'api/utils';
import { URLS } from 'config';
import { CloudService } from './types';

type GetCloudServicesConfig = ApiQueryConfig<CloudService[]>;

const url = `${URLS.app}/api/CloudServices`;

export const getCloudServices = createApiEndpoint<GetCloudServicesConfig>({
  method: 'GET',
  url,
  staleTime: 1000 * 60 * 60, // very rarely changes
});
